export default __webpack_public_path__ + "static/media/about-img.cdd665d8.png";